import { createContext } from "react"

export interface BenchmarkEntry {
  value: number
  count: number
  canonicalAid: string // dim_questions.aid BIGINT as string
  sector: string | null // sector actually matched for this entry — null if fell back to all/all
}

interface BenchmarkContextValue {
  benchmarksByAid: Record<string, BenchmarkEntry>
  benchmarkVisible: boolean
  benchmarkLoading: boolean
  openDetail: ((score: number, axisColor: string, questionAid: string | null, entry: BenchmarkEntry | null) => void) | null
}

export const BenchmarkContext = createContext<BenchmarkContextValue>({
  benchmarksByAid: {},
  benchmarkVisible: true,
  benchmarkLoading: false,
  openDetail: null
})
